import { HttpRequest, HttpEvent, HttpResponse, HttpHandlerFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { AlertService } from '@common/components/alert/alert.service';
import { ExcelExport, ExcelService } from '@common/services/excel';
import { LocalAuthService } from 'app/core/auth/auth.service';
import { Observable, throwError, Subject } from 'rxjs';
import { tap, catchError, finalize } from 'rxjs/operators';

export const HttpRequestInterceptor = (request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
    const alertService = inject(AlertService);
    const authService = inject(LocalAuthService);
        const excelService = inject(ExcelService);
    return next(request).pipe(tap(evt => {
            if (evt instanceof HttpResponse) {
                if (evt.body && evt.body["messages"]) {
                    
                    alertService.success(evt.body["messages"], null, { autoClose: true });
                }
                const body = evt.body;
                if (body && body["errorResult"] && Array.isArray(body["errorResult"]) && body["errorResult"].length > 0) {
                    const payload = body["errorResult"];
                    const keys = Object.keys(payload[0]);

                    const exportData: ExcelExport = {
                        data: payload,
                        mapping: keys.map(key => ({
                            colCode: key,
                            colName: key.toUpperCase()
                        }))
                    };

                    // Trigger download for skipped/invalid items even on success
                    excelService.exportAsExcel(exportData, "Skipped_Items_Report");
                }
            }
        }), catchError((err: HttpErrorResponse) => {
            switch (err.status) {
                case 0:
                    console.log("Network error:", err);
                    alertService.error("Please Check your Network Status!", err.statusText, { autoClose: true });
                    break;
                case 400:
                    // if (!Array.isArray(err.error.messages)) {
                    //     alertService.error(err.error, err.statusText, { autoClose: true });
                    // }
                    // else {
                    //     alertService.error(err.error.messages.join("\r\n"), err.statusText, { autoClose: true });                      
                    // }
                    const errorBody = err.error;
                    const messages = Array.isArray(errorBody.messages) 
                                     ? errorBody.messages.join("\r\n") 
                                     : (errorBody.messages || "Bad Request");

                    alertService.error(messages, err.statusText, { autoClose: true });

                    // --- START EXCEL DOWNLOAD LOGIC ---
                    if (errorBody.Result && Array.isArray(errorBody.Result) && errorBody.Result.length > 0) {
                        const payload = errorBody.Result;
                        
                        // Dynamically determine columns based on the first object keys
                        // Works for [{epc, reason}] or [{sku, reason}]
                        const keys = Object.keys(payload[0]);
                        
                        const exportData: ExcelExport = {
                            data: payload,
                            mapping: keys.map(key => ({
                                colCode: key,
                                colName: key.toUpperCase() // e.g. "EPC", "REASON"
                            }))
                        };

                        excelService.exportAsExcel(exportData, "Error_Report");
                    }
                    // --- END EXCEL DOWNLOAD LOGIC ---

                   
                    return throwError(() => new Error(err.error.messages));
                case 401:
                    alertService.error("Authorization needed!", err.statusText, { autoClose: true });
                    break;
                case 403:
                    if (err.error && Array.isArray(err.error.messages)) {
                        alertService.error(err.error.messages.join("\r\n"), err.statusText, { autoClose: true });
                        setTimeout(() => {
                             authService.signOut();
                        }, 1000);
                       
                    } else if (err.error && err.error.messages) {
                        alertService.error(err.error.messages, err.statusText, { autoClose: true });
                    } else {
                        alertService.error("Request not allowed!", err.statusText, { autoClose: true });
                    }
                    break;
                case 404:
                    if (!Array.isArray(err.error.messages)) {
                        alertService.error(err.error, err.statusText, { autoClose: true });
                    }
                    else {
                        alertService.error(err.error.messages.join("\r\n"), err.statusText, { autoClose: true });
                    }
                    return throwError(() => new Error(err.error.messages));
                case 500:
                    alertService.error("Opps! Server encounter an issue with this request.", err.statusText, { autoClose: true });
                    break;                    
                default:
                    alertService.error("Unknown Error!", err.statusText, { autoClose: true });
                    break;
            }
            // For any error not return above..
            return throwError(() => new Error(err.message));
        }), finalize(() => {
        }))
    }